import { useState, useEffect } from 'react';
import GradeService from '../services/grades.services';


const StudentGrades = () =>{

   const [enrollment,setEnrollment] = useState("");
   const [periods,setPeriod] = useState([]);
   const [name,setName] = useState("");
   const [selectedYear, setSelected] = useState();
   const [currentYear, setCurrentYear] = useState();
   const [selectedPeriod,setSelectedPeriod] = useState();
   const [session, setSession] = useState([]);
const [gradesValidator, setGradesValidator] = useState(false);
   const [loading, setLoading] = useState(false);

   const gradeService = new GradeService();

   
   useEffect(()=>{
      setEnrollment(localStorage.getItem("userIdLoggin"));
      setName(localStorage.getItem("userName"));
      setCurrentYear(new Date().getFullYear());

   },[]);

   const findPeriods = event => {
      setSelected(event.target.value);
      if(event.target.value === "#"){
         setPeriod([]);
      }
      gradeService.getPeriodsByYear(event.target.value).then((value) => {
         setPeriod([]);
         const data = value.data.data;
         setPeriod(data);
      });
   };


   const findGrades = async (e) => {
    e.preventDefault();
    setLoading(true);
    gradeService.getStudenCalification(selectedPeriod, selectedYear).then( async (value) =>{
        console.log(value);
        if(value.data.data==='Estudiante no tiene calificaiones'){
            setGradesValidator(false);
            setLoading(false);
        }
        else{
            let allData=[];
            allData=value.data.data;
            for (const [key, values] of Object.entries(value.data.data)){

                await gradeService.getGradesCalificationLiteral(values.calification).then(async (literal) =>{      
                  allData[key].literalGrade=literal.data.data.literal;  
                })
            }                    
            setGradesValidator(true);
            setLoading(false);
            setSession(allData);
        }
        
    });
}

   const handleSelectedPeriod = (value) => {
      setSelectedPeriod(event.target.value);
   };


   return (
      <div className="pt-0 sm:pt-10">
         <div className="p-12">
            <h1 className="mb-0 text-xl font-semibold text-green-600">Consultar calificaciones</h1>
            <div className="grid grid-cols-1 gap-4 pt-6 mb-12 bg-white lg:grid-cols-4">
               <div className="">
                  <label  className="block mb-2 ml-5 text-sm font-medium text-gray-900">Matrícula</label>
                  <input id="matricula" type="text" placeholder="Matrícula" className="w-full px-4 py-2 border-2 rounded-2xl bg-gray-50" value={enrollment} disabled />
               </div>
               <div className="">
                  <label  className="block mb-2 ml-5 text-sm font-medium text-gray-900">Nombre</label>
                  <input id="nombre" type="text" placeholder="Nombre" className="w-full px-4 py-2 border-2 rounded-2xl bg-gray-50" value={name} disabled />
               </div>
               <div className="">
                  <label className="block mb-2 ml-5 text-sm font-medium text-gray-900">Año</label>
                  <select value={selectedYear} onChange={findPeriods} id="year" className="w-full px-4 py-2 border-2 rounded-2xl bg-gray-50">
                     <option value="#">Seleccione</option>
                     <option value={parseInt(currentYear)-4}>{currentYear-4}</option>
                     <option value={parseInt(currentYear)-3}>{currentYear-3}</option>
                     <option value={parseInt(currentYear)-2}>{currentYear-2}</option>
                     <option value={parseInt(currentYear)-1}>{currentYear-1}</option>
                     <option value={parseInt(currentYear)}>{currentYear}</option>

                  </select>
               </div>
               <div className="">
                  <label className="block mb-2 ml-5 text-sm font-medium text-gray-900">Periodo</label>
                  <select id="periodo" value={selectedPeriod} onChange={handleSelectedPeriod} className="w-full px-4 py-2 border-2 rounded-2xl bg-gray-50">
                  <option value="#">Seleccione</option>
                     {
                        periods.map((value) => {
                           return <>
                           <option value={value.id}>{value.name}</option>
                           </>
                        })
                     }
                  </select>
               </div>
               <div className="">
                  <button onClick={findGrades} disabled={loading} className="px-4 py-2 font-semibold text-white uppercase bg-green-600 rounded-full shadow-lg cursor-pointer hover:bg-green-700">
                  {loading ? (
							<svg
								className='inline w-8 h-8  text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300'
								viewBox='0 0 100 101'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
									fill='currentColor'
								/>
								<path
									d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
									fill='currentFill'
								/>
							</svg>
						) : (
							'Buscar'
						)}</button>
               </div>

            </div>
            <div className="relative overflow-x-auto border sm:rounded-lg">
                       <table className="w-full text-sm text-left text-gray-500">
                           <thead className="text-xs text-white uppercase bg-green-600">
                               <tr>
                                   <th scope="col" className="px-6 py-3 border-r">
                                    Código asignatura
                                   </th>
                                   <th scope="col" className="px-6 py-3 border-r">
                                    Asignatura
                                   </th>
                                   <th scope="col" className="px-6 py-3 border-r">
                                    Grupo
                                   </th>
                                   <th scope="col" className="px-6 py-3 border-r">
                                    Calificación
                                   </th>
                               </tr>
                           </thead>
                           <tbody>
                               {
                                gradesValidator ? (
                                session.map((value)=>(
                                    <tr className="bg-white border-t border-gray-200" key={value.groupId}>
                                        <td className="px-6 py-2">
                                            {value?.subjectCode}
                                        </td>
                                        <td className="px-6 py-2">
                                            {value?.subject}
                                        </td>
                                        <td className="px-6 py-2">
                                            {value?.groupNumber}
                                        </td>
                                        <td className="px-6 py-2">
                                            {value?.literalGrade}
                                        </td>
                                    </tr>
                                ))) : (
                                <tr>
                                    <td colSpan={6} className='text-center'>No hay data que mostrar</td>
                                </tr>
                                )
                               }
                               
                           </tbody>
                       </table>
                   </div>
         </div>
      </div>
   );
}

export default StudentGrades;
